import $ from 'jquery';

export default class Tablist {

    constructor(el) {
        this.tablist = el;
        this.tabs = this.tablist.find('.js-tab');
        this.panes = this.tablist.find('.js-pane');
        this.setActiveTab();
        this.activePane = this.panes.filter('.is-active');
        this.activeTab = this.tabs.filter('.is-active');

        this.handleEvents();

        // quick fix - to handle in the handlebars template cms side
        this.removeEmptyLegals(el);
    }

    removeEmptyLegals(el) {
        this.panes.each( (i, pane) => {
            let legals = $(pane).find('.dcw_legals');

        if (legals && legals.find('.dcw_legals_text').length < 1) {
            legals.remove();
        }
    });
    }

    setActiveTab() {
        this.setActiveTabFromId(
            this.buildIdFromHash(window.location.hash)
        );
    }

    setScrollTop() {
        $(window).on('beforeunload', function() {
            $(window).scrollTop( $('.dcw_banner-heading_desc').offset().top );
        });
    }

    setActiveTabFromId(tabId) {
        var tab = [];
        var tabId = tabId === '' ?
            this.tabs.eq(0) :
            tabId;

        var format = /[ !@$%^&*()+=\[\]{};':"\\|,.<>\/?]/;

        if(!format.test(tabId)) {
            tab = this.tablist.find(tabId);
        }

        if (tab.length === 0) {
            tab = this.tabs.eq(0);
        }else {
            this.setScrollTop();
        }

        tab.addClass('is-active');
        tab.find('button').attr('aria-expanded', 'true');

        $('#' + tab.find('button').attr('aria-controls'))
            .addClass('is-active');
    }

    handleEvents() {
        let self = this;
        this.tabs.click(
            this.showPane(self)
        );
    }

    showPane(self) {
        return function (e) {
            let newTab = $(this),
                newHash = newTab.attr('id');

            self.changeActiveTab(self, newTab);
            self.updateUrlHash(newHash);
        };
    }

    updateUrlHash(tabId) {
        window.location.hash = this.buildHashName(tabId);
    }

    buildHashName(id) {
        return '#' + id.split('-').slice(2).join('-');
    }

    buildIdFromHash(hash) {
        return hash != '' ?
            '#' + 'dcw-tab-' + hash.slice(1) || null :
            '';
    }

    changeActiveTab(self, newTab) {
        let tabBtn = newTab.find('button');
        let pane = self.getControlPane(tabBtn);

        newTab.addClass('is-active');
        tabBtn.attr('aria-expanded', 'true');
        self.activeTab.removeClass('is-active');
        self.activeTab.find('button').attr('aria-expanded', 'false');

        self.onTransitionEnd(self.activePane, function () {
            self.activePane.removeClass('is-active-remove');
            self.activePane.removeClass('is-active');

            pane.addClass('is-active-add');
            setTimeout(() => {
                pane.addClass('is-active');
            pane.removeClass('is-active-add');
        }, 30);

            self.activePane = pane;
            self.activeTab = newTab;
        });

        self.activePane.addClass('is-active-remove');
    }

    getControlPane(tab) {
        return this.tablist
            .find(
                '#' + tab.attr('aria-controls')
            );
    }

    onTransitionEnd(element, onTransitionEndCallBack) {
        element.on('transitionend', function () {
            element.off('transitionend');
            onTransitionEndCallBack();
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/tablist/index.js